import { Arg, Metadata } from '../../../utils/spds/metadata';
import { reads } from 'macro-decorators';
import Container from './container.gjs';
import Super from './base.gjs';
import styles from './character-counter.module.scss';

const METADATA = Metadata.define({
  description:
    'The character counter actively displays the ratio of characters used and the total character limit. The character counter should appear on the bottom right of our text inputs',
  meta: {
    limit: Arg.number({ description: 'The maximum number of characters allowed' })
      .required()
      .initial(200),
    value: Arg.string({ description: 'The current value to count characters from' }).initial(
      'Lorem ipsum dolor sit amet'
    ),
  },
  name: 'Character Counter',
  resources: {
    zeroheight:
      'https://www.simplepractice.design/1d0abbc0a/p/471adb-text-inputs/t/page-471adb-68575769-9',
  },
});

export default class SpdsCoreCharacterCounter extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-text-input-character-counter';
  classesToMap = ['over'];
  styles = styles;

  @reads('value.length', 0) charCount;

  get over() {
    return this.charCount > this.args.limit;
  }

  get value() {
    return this.argOrDefault('value');
  }

  <template>
    <Container
      @fitContent={{true}}
      class={{this.classes}}
      data-test-spds-character-counter
      {{this.validateArguments}}
      ...attributes
    >
      {{this.charCount}}/{{@limit}}
    </Container>
  </template>
}

export const SPDS_CORE_CHARACTER_COUNTER_METADATA = SpdsCoreCharacterCounter.metadata;
